/* PRYME redesign draft: header menu, scroll reveals, flavour carousel, opening animation, locator hand-off */
(function(){
  "use strict";
  var root=document.documentElement,q=new URLSearchParams(location.search),shot=q.has("shot");
  if(shot){root.classList.add("pr-shot");document.querySelectorAll('.pr-scope img[loading="lazy"]').forEach(function(i){i.loading="eager";});}

  /* Opening animation */
  var intro=document.getElementById("pr-intro");
  if(intro&&root.classList.contains("pr-intro-on")){
    var vid=intro.querySelector("video"),mob=window.matchMedia("(max-width:760px)").matches,done=false;
    intro.style.backgroundImage="url("+vid.getAttribute(mob?"data-pm":"data-pd")+")";
    vid.poster=vid.getAttribute(mob?"data-pm":"data-pd");
    vid.src=vid.getAttribute(mob?"data-m":"data-d");
    var pr=vid.play();if(pr&&pr.catch)pr.catch(function(){});
    var finish=function(){if(done)return;done=true;try{sessionStorage.setItem("pryme-intro","1");}catch(e){}
      root.classList.remove("pr-intro-on");vid.pause();vid.removeAttribute("src");if(intro.parentNode)intro.parentNode.removeChild(intro);};
    var skip=function(){if(done||intro.classList.contains("pr-out"))return;intro.classList.add("pr-out");setTimeout(finish,420);};
    intro.addEventListener("animationend",function(e){if(e.target===intro)finish();});
    intro.addEventListener("click",skip);intro.addEventListener("touchstart",skip,{passive:true});
    document.addEventListener("keydown",function(){if(!done)skip();});
    setTimeout(finish,4200);
  } else if(intro){intro.parentNode.removeChild(intro);root.classList.remove("pr-intro-on");}

  /* Scroll reveals */
  var rvs=document.querySelectorAll(".pr-rv,.pr-rv-kids");
  var design=window.Shopify&&Shopify.designMode;
  var anim=root.classList.contains("pr-anim");
  if(shot||design||!anim||!("IntersectionObserver" in window)){rvs.forEach(function(el){el.classList.add("pr-in");});}
  else{var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add("pr-in");io.unobserve(en.target);}});},{rootMargin:"0px 0px -8% 0px",threshold:.12});
    rvs.forEach(function(el){io.observe(el);});}

  /* Mobile menu */
  var mb=document.querySelector(".pr-menu-btn"),mn=document.getElementById("pr-mnav");
  if(mb&&mn){mb.addEventListener("click",function(){var o=mn.classList.toggle("pr-open");mb.setAttribute("aria-expanded",o?"true":"false");});
    mn.addEventListener("click",function(e){if(e.target.tagName==="A"){mn.classList.remove("pr-open");mb.setAttribute("aria-expanded","false");}});}
  /* Desktop dropdowns: close on outside click */
  document.addEventListener("click",function(e){document.querySelectorAll(".pr-nav details[open]").forEach(function(d){if(!d.contains(e.target))d.removeAttribute("open");});});

  /* Looping carousel */
  document.querySelectorAll("[data-pr-car]").forEach(function(car){
    var track=car.querySelector(".pr-car-track");if(!track)return;
    var real=Array.prototype.slice.call(track.children),n=real.length;if(n<2)return;
    function clone(el){var c=el.cloneNode(true);c.setAttribute("aria-hidden","true");c.setAttribute("inert","");c.removeAttribute("data-shopify-editor-block");
      c.querySelectorAll("a,button").forEach(function(a){a.setAttribute("tabindex","-1");});
      c.querySelectorAll("img").forEach(function(i){i.loading="lazy";i.removeAttribute("fetchpriority");});return c;}
    var before=document.createDocumentFragment(),after=document.createDocumentFragment();
    real.forEach(function(el){before.appendChild(clone(el));after.appendChild(clone(el));});
    track.insertBefore(before,track.firstChild);track.appendChild(after);
    function off(i){return track.children[i].getBoundingClientRect().left-track.getBoundingClientRect().left+track.scrollLeft;}
    function setW(){return off(2*n)-off(n);}
    function step(){return off(n+1)-off(n);}
    function home(){track.style.scrollSnapType="none";track.scrollLeft=off(n);if(!shot)requestAnimationFrame(function(){track.style.scrollSnapType="";});}
    home();
    var t;
    function fix(){var w=setW(),x=track.scrollLeft,s0=off(n);
      if(x<s0-w/2||x>=s0+w-2){track.style.scrollSnapType="none";track.scrollLeft=x<s0-w/2?x+w:x-w;requestAnimationFrame(function(){track.style.scrollSnapType="";});}}
    track.addEventListener("scroll",function(){clearTimeout(t);t=setTimeout(fix,140);},{passive:true});
    var lw=window.innerWidth;
    window.addEventListener("resize",function(){if(shot){home();return;}if(window.innerWidth===lw)return;lw=window.innerWidth;clearTimeout(t);t=setTimeout(home,150);});
    var reduce=window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    car.querySelectorAll("[data-dir]").forEach(function(btn){btn.addEventListener("click",function(){fix();track.scrollBy({left:step()*Number(btn.getAttribute("data-dir")),behavior:reduce?"auto":"smooth"});});});
    track.addEventListener("keydown",function(e){if(e.key==="ArrowRight"||e.key==="ArrowLeft"){e.preventDefault();fix();track.scrollBy({left:step()*(e.key==="ArrowRight"?1:-1),behavior:reduce?"auto":"smooth"});}});
  });

  /* Store locator hand-off: the homepage finder sends ?q= to the Where to Buy page; fill its search box */
  var term=q.get("q"),pm=document.getElementById("pm-q");
  if(term&&pm){var tries=0;(function fill(){var el=document.getElementById("pm-q");if(!el)return;
    el.value=term.slice(0,80);el.dispatchEvent(new Event("input",{bubbles:true}));
    if(++tries<3)setTimeout(fill,tries*700);})();
    try{pm.scrollIntoView({block:"center"});}catch(e){}}

  /* Flavour burst on touch screens: a lighter version plays after a tap, and while a card is in view only when the entry animation is on. Passive, so links and scrolling are never blocked. */
  if(window.matchMedia&&matchMedia("(hover: none)").matches&&!matchMedia("(prefers-reduced-motion: reduce)").matches){
    var cards=document.querySelectorAll(".pr-card");
    if(cards.length&&anim&&"IntersectionObserver" in window){
      var bio=new IntersectionObserver(function(es){es.forEach(function(en){en.target.classList.toggle("pr-burst",en.isIntersecting&&en.intersectionRatio>=.6);});},{threshold:[0,.6,1]});
      cards.forEach(function(c){bio.observe(c);});
    }
    cards.forEach(function(c){c.addEventListener("touchstart",function(){c.classList.add("pr-burst");},{passive:true});});
  }
})();

/* r10: Meet the squad spotlight carousel (Layout = Spotlight carousel). Big centre bag, neighbours to the sides.
   Arrows, arrow keys (Home/End too), swipe, click a side bag to bring it to the centre, click the centre bag to open it. */
(function(){
  "use strict";
  var reduce=window.matchMedia&&matchMedia("(prefers-reduced-motion: reduce)").matches;
  function init(sp){
    if(!sp||sp.getAttribute("data-pr-ready"))return;sp.setAttribute("data-pr-ready","1");
    var items=Array.prototype.slice.call(sp.querySelectorAll(".pr-spot-item")),panels=Array.prototype.slice.call(sp.querySelectorAll(".pr-spot-panel")),
        n=items.length,cur=0,stage=sp.querySelector(".pr-spot-stage"),status=sp.querySelector(".pr-spot-status");
    if(!n||!stage)return;
    function pos(k){var d=((k-cur)%n+n)%n;if(d>n/2)d-=n;return Math.abs(d)>2?"out":String(d);}
    function go(k,say){cur=((k%n)+n)%n;
      items.forEach(function(it,j){it.setAttribute("data-pos",pos(j));it.classList.toggle("is-active",j===cur);
        var b=it.querySelector(".pr-spot-pick"),nm=it.getAttribute("data-name")||"";if(b)b.setAttribute("aria-label",(j===cur?"Shop ":"Show ")+nm);});
      panels.forEach(function(p,j){p.hidden=j!==cur;});
      if(say&&status)status.textContent=(items[cur].getAttribute("data-name")||"")+", "+(cur+1)+" of "+n;}
    go(0,false);
    if(n<2){sp.querySelectorAll(".pr-spot-arrow").forEach(function(a){a.hidden=true;});}
    sp.querySelectorAll(".pr-spot-arrow").forEach(function(btn){btn.addEventListener("click",function(){go(cur+Number(btn.getAttribute("data-dir")),true);});});
    stage.addEventListener("keydown",function(e){
      if(e.target!==stage)return;
      if(e.key==="ArrowRight"){e.preventDefault();go(cur+1,true);}else if(e.key==="ArrowLeft"){e.preventDefault();go(cur-1,true);}
      else if(e.key==="Home"){e.preventDefault();go(0,true);}else if(e.key==="End"){e.preventDefault();go(n-1,true);}});
    var sx=null,sy=0,moved=false;
    stage.addEventListener("pointerdown",function(e){if(e.button>0)return;sx=e.clientX;sy=e.clientY;moved=false;});
    stage.addEventListener("pointermove",function(e){if(sx!==null&&Math.abs(e.clientX-sx)>10)moved=true;});
    stage.addEventListener("pointerup",function(e){if(sx===null)return;var dx=e.clientX-sx,dy=e.clientY-sy;sx=null;
      if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){moved=true;go(cur+(dx<0?1:-1),true);}});
    stage.addEventListener("pointercancel",function(){sx=null;});
    stage.addEventListener("dragstart",function(e){e.preventDefault();});
    stage.querySelectorAll("img").forEach(function(i){i.setAttribute("draggable","false");});
    items.forEach(function(it,j){var b=it.querySelector(".pr-spot-pick");if(!b)return;
      b.addEventListener("click",function(e){if(moved){moved=false;e.preventDefault();return;}
        if(j===cur){var a=panels[j]&&panels[j].querySelector("a[href]");if(a)window.location.href=a.href;}else go(j,true);});});
    document.addEventListener("shopify:block:select",function(e){var j=items.indexOf(e.target);if(j>-1)go(j,false);});
    if(reduce)sp.classList.add("pr-spot-still");
  }
  document.querySelectorAll("[data-pr-spot]").forEach(init);
  document.addEventListener("shopify:section:load",function(e){if(e.target&&e.target.querySelectorAll)e.target.querySelectorAll("[data-pr-spot]").forEach(init);});
})();
